import { Timer1 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import TimezonesMenu from '../../../TimezonesMenu'

import { useCustomerContext } from '../../../../../providers/CustomerProvider'
import useStyles from './styles'

const TimezoneSection: React.FC<{}> = () => {
  const theme = useTheme()
  const { values, handleChange } = useCustomerContext()

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.label}>
        <Timer1
          size={theme.size.base}
          variant='Bold'
          className={classes.icon}
          color='grey'
        />{' '}
        TIMEZONE
      </div>

      <TimezonesMenu
        selected={values.timezone}
        onSelect={val => handleChange(val, 'timezone')}
        className={classes.input}
      />
    </div>
  )
}

export default TimezoneSection
